import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { SystemEventThreadsDto } from '@/interfaces/system-events/SystemEventThreads.dto'
import { SystemEventThreadPatchDto } from '@/interfaces/system-events/SystemEventThreadPatch.dto'
import { SystemEventRulesDto } from '@/interfaces/system-events/SystemEventRules.dto'
import { SystemEventRulePatchDto } from '@/interfaces/system-events/SystemEventRulePatch.dto'
import { SystemEventsDto } from '@/interfaces/system-events/SystemEvents.dto'
import { SystemEventStatusesDto } from '@/interfaces/system-events/SystemEventStatuses.dto'
import { SystemEventPatchDto } from '@/interfaces/system-events/SystemEventPatch.dto'

export default class SystemEventsService extends ApiService {
    async getSystemEventThreads(
        params?: IRequestParameters,
    ): Promise<[SystemEventThreadsDto[], PageNumberPagination] | null> {
        return this.request<undefined, [SystemEventThreadsDto[], PageNumberPagination]>(
            'GET',
            '/system-events/system-event-threads',
            params,
            undefined,
            undefined,
            'getSystemEventThreads',
        ).catch(() => null)
    }

    async pathSystemEventThread(payload: SystemEventThreadPatchDto): Promise<SystemEventThreadsDto | null> {
        return this.request<SystemEventThreadPatchDto, SystemEventThreadsDto>(
            'PATCH',
            `/system-events/system-event-threads`,
            undefined,
            payload,
            undefined,
            'pathSystemEventThread',
        ).catch(() => null)
    }

    async countThreadSystemEvents(systemEventThreadId: number): Promise<Record<string, number> | null> {
        return this.request<undefined, Record<string, number>>(
            'POST',
            `/system-events/system-event-threads/${systemEventThreadId}/count-system-events`,
            undefined,
            undefined,
            undefined,
            'countThreadSystemEvents',
        ).catch(() => null)
    }

    async getSystemEventRules(
        params?: IRequestParameters,
    ): Promise<[SystemEventRulesDto[], PageNumberPagination] | null> {
        return this.request<undefined, [SystemEventRulesDto[], PageNumberPagination]>(
            'GET',
            '/system-events/system-event-rules',
            params,
            undefined,
            undefined,
            'getSystemEventRules',
        ).catch(() => null)
    }

    async pathSystemEventRule(payload: SystemEventRulePatchDto): Promise<SystemEventRulesDto | null> {
        return this.request<SystemEventRulePatchDto, SystemEventRulesDto>(
            'PATCH',
            `/system-events/system-event-rules`,
            undefined,
            payload,
            undefined,
            'pathSystemEventRule',
        ).catch(() => null)
    }

    async countRuleSystemEvents(systemEventRuleId: number): Promise<Record<string, number> | null> {
        return this.request<undefined, Record<string, number>>(
            'POST',
            `/system-events/system-event-rules/${systemEventRuleId}/count-system-events`,
            undefined,
            undefined,
            undefined,
            'countRuleSystemEvents',
        ).catch(() => null)
    }

    async getRuleSystemEventsAverageTime(systemEventRuleId: number): Promise<{ averageTime: string } | null> {
        return this.request<undefined, { averageTime: string }>(
            'POST',
            `/system-events/system-event-rules/${systemEventRuleId}/system-events-average-time`,
            undefined,
            undefined,
            undefined,
            'getRuleSystemEventsAverageTime',
        ).catch(() => null)
    }

    async getSystemEvents(params?: IRequestParameters): Promise<[SystemEventsDto[], PageNumberPagination] | null> {
        return this.request<undefined, [SystemEventsDto[], PageNumberPagination]>(
            'GET',
            '/system-events/system-events',
            params,
            undefined,
            undefined,
            'getSystemEvents',
        ).catch(() => null)
    }

    async getSystemEventStatuses(
        params?: IRequestParameters,
    ): Promise<[SystemEventStatusesDto[], PageNumberPagination] | null> {
        return this.request<undefined, [SystemEventStatusesDto[], PageNumberPagination]>(
            'GET',
            '/system-events/system-event-statuses',
            params,
            undefined,
            undefined,
            'getSystemEventStatuses',
        ).catch(() => null)
    }

    async pathSystemEvent(payload: SystemEventPatchDto): Promise<SystemEventsDto | null> {
        return this.request<SystemEventPatchDto, SystemEventsDto>(
            'PATCH',
            `/system-events/system-events`,
            undefined,
            payload,
            undefined,
            'pathSystemEvent',
        ).catch(() => null)
    }

    async releaseSystemEvent(id: number): Promise<SystemEventsDto | null> {
        return this.request<undefined, SystemEventsDto>(
            'POST',
            `/system-events/system-events/${id}/release`,
            undefined,
            undefined,
            undefined,
            'releaseSystemEvent',
        ).catch(() => null)
    }
}
